import { editUserImage, editUserProfile, saveGreeting } from '@/store/actions/forms';
import { editEmail } from '@/store/actions/setting';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetUserDeatil, LoginUser, LogoutUser } from '@/store/actions';
import { SignInResponse } from '@/@types/openapi-imports';
import { HttpApiResponse } from '@/api/interfaces';

// Initial state for the login slice
const initialLoginState = {
  isLoading: false,
  userDetails: '',
  userGreeting: '',
  isChangeSetting: false,
  userJoinedTeams: [''],
  isAuthenticated: true
};

export const GoogleUser = createAsyncThunk<any, any>('userDetails/login', async (payload: any) => {
  return payload;
});

export const ChangeSetting = createAsyncThunk<any, any>('isChangeSetting/login', async (payload: boolean) => {
  return payload;
});

// Create the login slice using createSlice
export const loginSlice = createSlice({
  name: 'login',
  initialState: initialLoginState,
  reducers: {
    // biome-ignore lint/suspicious/noEmptyBlockStatements: TODO
    clearLoginState: (state: any) => {}
  },
  extraReducers: (builder: any) => {
    builder

      .addCase(LoginUser.pending, (state: any) => {
        state.userDetails = '';
        state.isLoading = true;
        state.isAuthenticated = true;
      })

      .addCase(LoginUser.fulfilled, (state: any, payload: PayloadAction<HttpApiResponse<SignInResponse>>) => {
        state.userDetails = payload.payload.data;
        state.isLoading = false;
        state.isAuthenticated = true;
      })
      .addCase(LoginUser.rejected, (state: any) => {
        state.userDetails = '';
        state.isLoading = true;
        state.isAuthenticated = true;
      })

      .addCase(editEmail.pending, (state: any) => {
        state.isLoading = true;
      })
      .addCase(editEmail.fulfilled, (state: any, { payload }: any) => {
        state.isLoading = false;
        if (payload.data !== undefined) {
          state.userDetails.email = payload.data;
        }
      })

      .addCase(editEmail.rejected, (state: any) => {
        state.isLoading = true;
      })

      .addCase(LogoutUser.fulfilled, (state: any) => {
        state.isAuthenticated = true;
      });
  }
});

// Export the action creator and reducer
export const { clearLoginState } = loginSlice.actions;
export default loginSlice.reducer;
